import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "facade-gallery-container" }
const _hoisted_2 = {
  key: 0,
  class: "card facade-gallery-card"
}
const _hoisted_3 = {
  key: 0,
  class: "facade-items-wr"
}
const _hoisted_4 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "facade-gallery-header" }, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "title" }, "Facade Gallery", -1)),
        _createElementVNode("button", {
          class: "button default primary add-btn-primary",
          onClick: $setup.openModal
        }, "Add Facade")
      ]),
      ($setup.facades?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!$setup.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.facades, (facade) => {
                    return (_openBlock(), _createBlock($setup["FacadeItemCard"], {
                      key: facade._id,
                      facade: facade,
                      onDelete: (facade) => $setup.confirmDelete(facade),
                      onUpdate: (facade) => $setup.updateFacade(facade)
                    }, null, 8, ["facade", "onDelete", "onUpdate"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.isConfirmDeleteFacadeModalOpen,
      deleteItem: `facade '${$setup.facadeDelete?.name}'`,
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => ($setup.deleteFacade($setup.facadeDelete))),
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.isConfirmDeleteFacadeModalOpen = false))
    }, null, 8, ["isOpen", "deleteItem"])
  ], 64))
}